module.exports = __webpack_public_path__ + "f192858beb49d43e1efe9a619a4306bd.png";